import React, { Component } from 'react';
import { Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import bgImage from '../../components/backend/assets/images/authentication/img-auth-bg-2.jpg';
import { withNavigation } from "../../utils/withNavigation";

class AdminLoginPage extends Component {

  state = {

    website_name: "",
    website_logo: null,
    powered_by: "",
    preview_logo: null,

    username: "",
    password: "",
    error: "",
    loading: false,
  };


  API_BASE = axios.defaults.baseURL;
  PUBLIC_BASE = this.API_BASE.replace("/api", "");

  componentDidMount() {
    this.fetchFooterData();
  }

  fetchFooterData = async () => {
    try {
      const res = await axios.get("/theme_customizable");
      const d = res?.data?.data;
      if (d) {
        this.setState({
          website_name: d.website_name || "",
          powered_by: d.powered_by || "",
          preview_logo: d.website_logo ? `${this.PUBLIC_BASE}/${d.website_logo}` : null,
        });
      }
    } catch (error) {
      console.error("Footer fetch error:", error);
    }
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleLogin = async (e) => {
    e.preventDefault();
    this.setState({ loading: true, error: "" });

    const { username, password } = this.state;

    const loginUrl = username.startsWith("admin_")
      ? "/admin/login"
      : "/merchant/login";

    try {
      const res = await axios.post(loginUrl, { username, password });

      if (res.data.token) {
        const user = res.data.user;
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("auth_token", res.data.token);
        localStorage.setItem("user_id", user?.user_id || "");
        localStorage.setItem("fullname", user?.fullname || "");
        localStorage.setItem("dashboard", user?.dashboard || "");
        localStorage.setItem("bookings", user?.bookings || "");
        localStorage.setItem("posts", user?.posts || "");
        localStorage.setItem("customers", user?.customers || "");
        localStorage.setItem("coupons", user?.coupons || "");
        localStorage.setItem("admins", user?.admins || "");
        localStorage.setItem("seo_pages", user?.seo_pages || "");
        localStorage.setItem("additional_page", user?.additional_page || "");
        localStorage.setItem("landing_page", user?.landing_page || "");
        localStorage.setItem("theme_customization",user?.theme_customization || "");
        localStorage.setItem("settings", user?.settings || "");

        localStorage.setItem("user_role", user?.role || "");
        localStorage.setItem("user", JSON.stringify(user));

        // React Router navigation – no full page reload
        window.location.href = "/admin/dashboard";
        // this.props.navigate("/admin/dashboard");

      } else {
        this.setState({ error: "No token returned from API!" });
      }
    } catch (err) {
      if (err.response) {
        this.setState({
          error:
            err.response.data.message ||
            err.response.data.error ||
            "Invalid credentials or server error.",
        });
      } else if (err.request) {
        this.setState({ error: "No response from server." });
      } else {
        this.setState({ error: err.message });
      }
    }

    this.setState({ loading: false });
  };

  render() {

    const {
      website_name,
      preview_logo,
      powered_by,
      username,
      password,
      error,
      loading
    } = this.state;

    return (
      <>
        <div className="auth-main" style={{ backgroundImage: `url(${bgImage})` }}>
          <div className="auth-wrapper v2">
            <div className="auth-sidecontent">
              <div className="d-flex align-items-center w-100 justify-content-center">
                <div className="col-md-8">
                  <h1 className="text-white mb-5">Login in {website_name}</h1>
                  <p className="text-white">{powered_by}</p>
                </div>
              </div>
            </div>
            <div className="auth-form">
              <div className="card my-0">
                <div className="card-body">
                  <div className="text-center">

                    {/* <Link to="#"><img src={logoDark} alt="logo" /></Link> */}

                    {preview_logo && (
                      <Link to="#">
                        <img
                          src={preview_logo}
                          alt="Logo"
                          className="img-fluid logo-lg"
                          style={{ width: "160px", paddingTop: "8px" }}
                        />
                      </Link>
                    )}

                  </div>
                  <h4 className="text-center f-w-500 mt-4 mb-3">Login</h4>

                  {error && <p style={{ color: "red" }}>{error}</p>}
                  {loading && <p>Logging in...</p>}

                  <form className="login-form" onSubmit={this.handleLogin}>
                    <div className="mb-3">
                      <input
                        type="text"
                        name="username"
                        className="form-control"
                        placeholder="Username"
                        value={username}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <input
                        type="password"
                        name="password"
                        className="form-control"
                        placeholder="Password"
                        value={password}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    <div className="text-center mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary shadow px-sm-4"
                        disabled={loading}
                      >
                        {loading ? "Logging in..." : "Login"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </>
    );
  }
}

export default withNavigation(AdminLoginPage);